import { render, staticRenderFns } from "./ComentarioClientes.vue?vue&type=template&id=44b8def2&scoped=true&"
import script from "./ComentarioClientes.vue?vue&type=script&lang=js&"
export * from "./ComentarioClientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b8def2",
  null
  
)

export default component.exports